import { dashboardIcon, reportIcon } from "assets/icons/svgIcons";

export default [
  {
    id: "reports",
    title: "Reports",
    pageTitle: "Reports",
    icon: reportIcon,
    // type: "collapse",
    navLink: "/reports",
    type: "item",
    permissions: [
      "super_admin",
      "site_admin",
      "organization_admin",
      "staff",
      "engineer",
      "hmc_admin",
      "hmc_supervisor",
      "hmc_technician",
      "qa",
      "helpdesk",
      "call_center",
      "head_of_department",
      "site_manager_call_center",
    ],
  },
];
